/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const NotificationEvent = Object.freeze({
  LICENSEE_CREATED: 'LICENSEE_CREATED',
  LICENSE_CREATED: 'LICENSE_CREATED',
  WARNING_LEVEL_CHANGED: 'WARNING_LEVEL_CHANGED',
  PAYMENT_TRANSACTION_PROCESSED: 'PAYMENT_TRANSACTION_PROCESSED',
});

export default NotificationEvent;
